module.exports = __webpack_public_path__ + "static/media/example_1.fbef4d19.png";